import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import { actionCreators, selectors as instanceSelectors } from 'dux/instances';
import AddUserForm from './AddUserForm';

const propTypes = {
  instanceId: PropTypes.string.isRequired,
  instanceService: PropTypes.string.isRequired,
  getInstanceDatabases: PropTypes.func.isRequired,
  pullInstanceDatabases: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
  getInstanceDatabases: instanceSelectors.getInstanceDatabases(state),
});

const mapDispatchToProps = {
  addInstanceUser: actionCreators.addInstanceUser,
  pullInstanceDatabases: actionCreators.pullInstanceDatabases,
};

class AddUserFormContainer extends React.Component {
  componentDidMount() {
    const { instanceId, instanceService, pullInstanceDatabases } = this.props;

    if (
      instanceService.toLowerCase() === 'cockroachdb' ||
      instanceService.toLowerCase() === 'mongodb'
    ) {
      pullInstanceDatabases(instanceId, instanceService.toLowerCase());
    }
  }

  render() {
    const { instanceId, getInstanceDatabases } = this.props;
    const databases = getInstanceDatabases(instanceId) || [];
    return <AddUserForm databases={databases} {...this.props} />;
  }
}

AddUserFormContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(AddUserFormContainer);
